import { render, staticRenderFns } from "./MaterialPanel.vue?vue&type=template&id=4010200c&scoped=true&"
import script from "./MaterialPanel.vue?vue&type=script&lang=js&"
export * from "./MaterialPanel.vue?vue&type=script&lang=js&"
import style0 from "./MaterialPanel.vue?vue&type=style&index=0&id=4010200c&prod&lang=less&scoped=true&"
import style1 from "./MaterialPanel.vue?vue&type=style&index=1&id=4010200c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4010200c",
  null
  
)

export default component.exports